import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormContentBlockerFieldTechnicalCriteria, FormContentBlockerFieldTechnicalRules, FormContentBlockerFieldTechnicalServices, FormContentBlockerFieldTechnicalTcfVendors, FormContentBlockerLayout } from "../..";
import { useFormContentBlocker, useI18n } from "../../../../../contexts";
import { FormHeadline, FormServiceLayout } from "../../..";
import { Form } from "antd";
import { Notices } from "../../../../common";
const FormContentBlockerFieldTechnicalCompose = (param)=>{
    let { servicesFieldProps, tcfVendorsFieldProps } = param;
    const { __ } = useI18n();
    const { template } = useFormContentBlocker();
    const notices = [
        {
            message: template == null ? void 0 : template.ruleNotice,
            severity: "info"
        }
    ].filter(Boolean).filter((param)=>{
        let { message } = param;
        return message;
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FormHeadline, {
                offset: FormContentBlockerLayout.labelCol.span,
                children: __("Technical Definition")
            }),
            notices.length > 0 && /*#__PURE__*/ _jsx(Form.Item, {
                wrapperCol: {
                    offset: FormServiceLayout.labelCol.span,
                    span: FormServiceLayout.wrapperCol.span
                },
                style: {
                    marginBottom: 0
                },
                children: /*#__PURE__*/ _jsx(Notices, {
                    notices: notices
                })
            }),
            /*#__PURE__*/ _jsx(FormContentBlockerFieldTechnicalRules, {}),
            /*#__PURE__*/ _jsx(FormContentBlockerFieldTechnicalCriteria, {}),
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.criteria !== nextValues.criteria,
                children: (param)=>{
                    let { getFieldValue } = param;
                    switch(getFieldValue("criteria")){
                        case "services":
                            return /*#__PURE__*/ _jsx(FormContentBlockerFieldTechnicalServices, {
                                ...servicesFieldProps
                            });
                        case "tcfVendors":
                            return /*#__PURE__*/ _jsx(FormContentBlockerFieldTechnicalTcfVendors, {
                                ...tcfVendorsFieldProps
                            });
                        default:
                            return null;
                    }
                }
            })
        ]
    });
};
export { FormContentBlockerFieldTechnicalCompose };
